<form [formGroup]="form">
  <ui-form [readonly]="readonly">
    <label *ngIf="label" [for]="fieldId">{{ label }} <em *ngIf="required">*</em></label>
    <div class="wrapper">
      <ui-select-country
        [arrow]="true"
        [disableLangSwitch]="disableLangSwitch"
        [formControlName]="'country'"
        [guestArea]="guestArea"
        [items]="countries"
        [loading]="false"
        [readonly]="readonly"
        [searchable]="true"
        type="ng-select-input-big"
        typeToSearchText="{{ (!guestArea ? 'SH.SEARCH_NUMBER' : 'GA.SEARCH_NUMBER') | translate }}"
      ></ui-select-country>
      <div class="wrapper">
        <div class="form-input form-input-prefix">{{ prefix }}</div>
        <input
          #input
          (blur)="onInputBlur()"
          (keydown.enter)="enter.emit()"
          (keyup)="onSanitizeInput()"
          (paste)="onSanitizeInput()"
          [formControlName]="'number'"
          [id]="fieldId"
          [readonly]="readonly"
          class="form-input form-input-number"
          formInput
          name="number"
          type="tel"
        />
      </div>
    </div>
  </ui-form>
</form>
